import React from 'react'
import Collection from '../common/collection'

function CollectionB({ props }) {
  return (
    <Collection
      alt="Niño de cera"
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/2.+ni%C3%B1o+cera21.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/2.+ni%C3%B1o+cera24.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/2.+ni%C3%B1o+cera25.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/2.+ni%C3%B1o+cera26.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/2.+ni%C3%B1o+cera63.jpg',
      ]}
    />
  )
}


export default CollectionB
